import { createSlice } from '@reduxjs/toolkit'

export interface IGeneralState {
    videoPlayerModalVisible: boolean
}

const initialState: IGeneralState = {
    videoPlayerModalVisible: false
}

const generalSlice = createSlice({
    name: 'ui/general',
    initialState,
    reducers: {
        changeVideoPlayerModalVisiblity(state, action) {
            state.videoPlayerModalVisible = action.payload.visible || false
        }
    }
})

export const generalActions = generalSlice.actions
export default generalSlice.reducer
